<div class="cerrix-banner" [class]="type">
    <span>{{ message }}</span>
</div>
